export const LAYOUT_SHOW_LOADING = 'LAYOUT_SHOW_LOADING';
export const LAYOUT_HIDE_LOADING = 'LAYOUT_HIDE_LOADING';
export const LAYOUT_CHANGE_LOCATION = 'LAYOUT_CHANGE_LOCATION';
export const LAYOUT_CHANGE_ORG = 'LAYOUT_CHANGE_ORG';
export const LAYOUT_UPDATE_ITEMS = 'LAYOUT_UPDATE_ITEMS';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/Layout/LayoutConstants.js